require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mba-mas-das-2-4-0.json") })
        }
      }, "path---mba-mas-das-2-4-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mba-mas-das-2-4-0!./.cache/json/mba-mas-das-2-4-0.json
// module id = 492
// module chunks = 231608221292675